function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconfinderArtificialIntelligence222890588 = function SvgIconfinderArtificialIntelligence222890588(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M43.314,41.929l-4.243-4.243l-2.331,1.399c-0.351-0.168-0.711-0.318-1.081-0.448L35,36h-6    l-0.659,2.637c-0.37,0.131-0.73,0.281-1.081,0.448l-2.331-1.399l-4.243,4.243l1.399,2.331c-0.168,0.351-0.318,0.711-0.448,1.081    L19,46v6l2.637,0.659c0.131,0.37,0.281,0.73,0.448,1.081l-1.399,2.331l4.243,4.243l2.331-1.399    c0.351,0.168,0.711,0.318,1.081,0.448L29,62h6l0.659-2.637c0.37-0.131,0.73-0.281,1.081-0.448l2.331,1.399l4.243-4.243    l-1.399-2.331c0.168-0.351,0.318-0.711,0.448-1.081L45,52v-6l-2.637-0.659c-0.131-0.37-0.281-0.73-0.448-1.081L43.314,41.929z",
    style: {
      fill: "#FFCB57"
    }
  })), React.createElement("g", null, React.createElement("rect", {
    height: 5,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 40,
    y: 16
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "49.707,25.707 48.293,24.293 51,21.586 51,9 53,9 53,22.414   ",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "57.707,31.707 56.293,30.293 59,27.586 59,17 61,17 61,28.414   ",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M41,14c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S42.654,14,41,14z M41,10    c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S41.552,10,41,10z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("rect", {
    height: 11,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 31,
    y: 9
  })), React.createElement("g", null, React.createElement("path", {
    d: "M32,7c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S33.654,7,32,7z M32,3c-0.552,0-1,0.448-1,1    s0.448,1,1,1s1-0.448,1-1S32.552,3,32,3z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M52,7c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S53.654,7,52,7z M52,3c-0.552,0-1,0.448-1,1    s0.448,1,1,1s1-0.448,1-1S52.552,3,52,3z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M60,15c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S61.654,15,60,15z M60,11    c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S60.552,11,60,11z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("rect", {
    height: 6,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 22,
    y: 16
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "14.293,25.707 11,22.414 11,9 13,9 13,21.586 15.707,24.293   ",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("polygon", {
    points: "8.293,33.707 3,28.414 3,17 5,17 5,27.586 9.707,32.293   ",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M23,14c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S24.654,14,23,14z M23,10    c-0.552,0-1,0.448-1,1s0.448,1,1,1s1-0.448,1-1S23.552,10,23,10z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M12,7c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S13.654,7,12,7z M12,3c-0.552,0-1,0.448-1,1    s0.448,1,1,1s1-0.448,1-1S12.552,3,12,3z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M4,15c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S5.654,15,4,15z M4,11c-0.552,0-1,0.448-1,1    s0.448,1,1,1s1-0.448,1-1S4.552,11,4,11z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M28,49c0,2.206,1.794,4,4,4s4-1.794,4-4s-1.794-4-4-4S28,46.794,28,49z M34,49c0,1.103-0.897,2-2,2    s-2-0.897-2-2s0.897-2,2-2S34,47.897,34,49z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M42.817,43.829l-1.805,0.861c0.152,0.32,0.289,0.647,0.408,0.983l0.179,0.507l2.4,0.601v4.438    l-2.4,0.601l-0.179,0.507c-0.119,0.336-0.255,0.662-0.407,0.981l-0.232,0.484l1.273,2.124l-3.139,3.139l-2.122-1.273l-0.484,0.231    c-0.32,0.152-0.647,0.289-0.983,0.408L34.819,58.6L34.219,61h-4.438l-0.601-2.4l-0.507-0.179    c-0.336-0.119-0.663-0.256-0.983-0.408l-0.484-0.231l-2.122,1.273l-3.69-3.69l-1.414,1.414l4.794,4.794l2.553-1.531    c0.057,0.024,0.114,0.048,0.171,0.071L28.219,63h7.562l0.722-2.888c0.057-0.023,0.114-0.047,0.171-0.071l2.553,1.531l5.346-5.346    l-1.53-2.553c0.023-0.058,0.047-0.114,0.07-0.171L46,52.781v-7.562l-2.888-0.722C43.021,44.271,42.922,44.048,42.817,43.829z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M18,45.219v7.562l2.888,0.722c0.092,0.226,0.19,0.449,0.296,0.668l1.803-0.863    c-0.152-0.319-0.288-0.646-0.407-0.981L22.4,51.819L20,51.219v-4.438l2.4-0.601l0.179-0.507c0.119-0.336,0.256-0.663,0.408-0.983    l0.231-0.484l-1.273-2.122l3.139-3.139l2.122,1.273l0.484-0.231c0.32-0.152,0.647-0.289,0.983-0.408l0.507-0.179l0.601-2.4h4.438    l0.601,2.4l0.507,0.179c0.336,0.119,0.663,0.256,0.983,0.408l0.484,0.231l2.122-1.273l3.69,3.69l1.414-1.414l-4.794-4.794    l-2.553,1.531c-0.057-0.024-0.114-0.048-0.171-0.071L35.781,35h-7.562l-0.722,2.888c-0.057,0.023-0.114,0.047-0.171,0.071    l-2.553-1.531l-5.346,5.346l1.531,2.553c-0.024,0.057-0.048,0.114-0.071,0.171L18,45.219z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M58.994,39.079C58.995,39.053,59,39.026,59,39c0-4.346-3.485-7.886-7.806-7.99    c-0.802-1.387-2.141-2.421-3.732-2.822C46.299,25.114,43.323,23,40,23c-1.235,0-2.452,0.289-3.559,0.842    C34.877,22.649,32.971,22,31,22c-2.305,0-4.511,0.892-6.175,2.461C23.935,24.166,22.987,24,22,24c-4.444,0-8.216,3.26-8.887,7.622    c-1.832,0.826-3.25,2.418-3.829,4.415C4.656,36.403,1,40.279,1,45c0,4.963,4.037,9,9,9h6v-2h-6c-3.859,0-7-3.141-7-7s3.141-7,7-7    c2.137,0,4.129,0.958,5.467,2.627l1.561-1.25c-1.427-1.782-3.437-2.92-5.649-3.259C12.128,34.265,13.922,33,16,33    c1.778,0,3.438,0.958,4.331,2.499l1.73-1.002C20.812,32.34,18.489,31,16,31c-0.242,0-0.48,0.015-0.716,0.039    C16.139,28.103,18.852,26,22,26c3.859,0,7,3.141,7,7h2c0-3.196-1.679-6.001-4.197-7.598C28.005,24.501,29.475,24,31,24    c1.718,0,3.374,0.637,4.664,1.792l0.557,0.498l0.636-0.393C37.808,25.311,38.895,25,40,25c2.179,0,4.159,1.215,5.208,3.058    C42.273,28.448,40,30.96,40,34h2c0-2.206,1.794-4,4-4s4,1.794,4,4s-1.794,4-4,4v2c3.309,0,6-2.691,6-6    c0-0.314-0.032-0.62-0.078-0.922c2.627,0.408,4.693,2.521,5.026,5.172C56.323,38.093,55.673,38,55,38    c-2.831,0-5.395,1.449-6.856,3.877l1.713,1.031C50.953,41.087,52.876,40,55,40c3.309,0,6,2.691,6,6s-2.691,6-6,6h-7v2h7    c4.411,0,8-3.589,8-8C63,43.044,61.385,40.464,58.994,39.079z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 54,
    y: 46
  }), React.createElement("path", {
    d: "M31,41v0.069c-3.94,0.495-7,3.859-7,7.931c0,4.411,3.589,8,8,8c4.072,0,7.436-3.06,7.931-7H40v-2    h-0.069c-0.453-3.612-3.319-6.477-6.931-6.931V41H31z M38,49c0,3.309-2.691,6-6,6s-6-2.691-6-6s2.691-6,6-6S38,45.691,38,49z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 9,
    y: 47
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 24,
    y: 30
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 36,
    y: 29
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconfinderArtificialIntelligence222890588, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconfinder_ArtificialIntelligence22_2890588.ab3b78b9.svg";
export { ForwardRef as ReactComponent };